import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

// 
import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import { Subscription } from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { SubjectService } from './../../../shared/models/subjectService.model';
import { HotToastService } from '@ngneat/hot-toast';
import { DomSanitizer } from '@angular/platform-browser';
import { Clipboard } from '@angular/cdk/clipboard'; // using the clipboard
import { buildResolutionOutcomeDisplay } from 'src/app/shared/functions/subject-service-resolution-outcome-display';

@Component({
  selector: 'app-subject-attempt-details-widget',
  templateUrl: './subject-attempt-details-widget.component.html',
  styleUrls: ['./subject-attempt-details-widget.component.css']
})
export class SubjectAttemptDetailsWidgetComponent implements OnInit {



   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   job: Object;
   job_id;

   @Input() intialCount? = 221;
   @Input() count? = this.intialCount;
   @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

   model: SubjectService;
 job_plaintiff_types: Object;
  subject_service_id: any;
  subject_service: any;

  @Input() subject_contact_email_id?: any;
  service_local_timezone: string;

  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  brand_id: any;
  subject_notes: Object;
 // bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  public mytime: Date = new Date();
  staffList: Object;
  serviceMethods: any;
  subjectRelationships: Object;
  exactServiceMethods: Object;
  get_latest_subject_service_id: any;
  subject_services: Object;
  serviceOutcomes: Object;
  assignedList: Object;
  assignedBrandList: Object;
  subjectServiceOutcome: Object;
  current_subject: Object;
  subjectLocationStatuss: any;
  subjectLocationStatussFound: Object;
  brand: Object;
  idx: any;
  title: any;
  current_service_number: any;
  converted_service_number: number;
  subjectAttemptTypesList: Object;
  subject_attempt_type_label: string;
  @Input() subject_id?: number; // impliments on changes.

       // access the template form
       @ViewChild('attemptForm') attemptForm: NgForm;
  all_router_details: string;
  nav: any;
  subjectAttemptType: Object;
  job_start_date: any;
  date_of_service: any;
  job_start_date_words: any;
  metric_1_date_1: any;
  metric_1_date_2: Date;

  allAttachments = [];

  property_images = [];
  property_sign_images = [];
  property_mail_images = [];
  property_vehicles_images = [];
  property_pets_images = [];
  property_occupancy_images = [];
  property_condition_images = [];
  property_type_images = [];
  service_file_array = [];

  set_job_file: number;
  set_subject_file: number;
  // service_file_array:any;
  subject_service_results: any;
  files: any;
  files2: any;
  files_property_sign_image: any[];
  files_property_type_images: any[];
  files_property_mail_images: any[];
  files_property_vehicles_images: any[];
  files_property_pets_images: any[];
  files_property_occupancy_images: any[];
  files_property_condition_images: any[];

  showAllAttachments: boolean;
  showRawParagraph: boolean;
  showRenderedParagraph: boolean;
  showManualParagraph: boolean;
  subject_name: string;

  isShow_attempt_details = false;
  resolution_outcomes: any[] = [];
  resolution_outcome_types: any[] = [];


 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
    public toastr: HotToastService,
    private sanitizer: DomSanitizer,
    private clipboard: Clipboard, // ciipboard
 ) { 

  this.nav = document.querySelector('nav.navbar');
  // this.toastr.setRootViewContainerRef(vcr);

// login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   // need to add this as routes does not work globally
   this.all_router_details = this.router.url;
   this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

 }

 // check for changes. to load data.
 ngOnChanges(changes) {


   this.model = new SubjectService();
  /// this.getJobPlaintiffTypes();
   if (changes.item_id) {
     // deal with asynchronous Observable result
   this.subject_service_id = changes.item_id.currentValue; // no dot value remember...
    // this.model.subject_contact_email_id = this.subject_contact_email_id;
     // this.getJob(this.job_id);
     
     this.getSubjectService(this.subject_service_id);
    //  this.getJob(this.item_data[0].job_id);

   }
 }


 ngOnInit() {
  this.getResolutionOutcomeDisplayData();

 }

 // Functions

// :: converted gets all the records  converted over for readablilty
 getSubjectService(subject_service_id) {
  this._demoService.getSubjectServiceConverted(subject_service_id).subscribe(
     data => { this.subject_service = data;
      let res = data[0];


      this.service_local_timezone = res.service_local_timezone;

      // Run the job data queries.
      this.subject_id = res.subject_id;
      this.subject_attempt_type_label = res.subject_attempt_type_name;
      this.date_of_service =  res.date_service;

      this.getServiceMethods();
      this.getServiceOutcomes();
      this.getSubjectRelationships();
      this.getExactServiceMethods();
  
      this.getSubjectAttemptTypes();
      // this.model.date_service = this.mytime;
      // this.model.time_service = this.mytime;
  
     // this.model.who_service = this.sessionUserId;
     this.getSubjectAgentBrandsAssigned(this.subject_id);
     this.getJobSubject(this.subject_id);
     this.getSubjectLocationStatuss();
     this.getSubjectLocationStatussFound();
     // sets the label of attempt type on load for edit component.
     this.getSubjectAttemptType(res.subject_attempt_type_id);

      this.getJob(res.job_id);
      this.getResolutionOutcomeDisplayData();



// Load the attached files from server_files_array
              // Count items of brand search to loop through
              this.service_file_array = JSON.parse(data[0].service_file_array); // parse this first...!!!
         
         // array 2
              this.property_images = JSON.parse(data[0].property_images); // parse this first...!!!
              this.property_sign_images = JSON.parse(data[0].property_sign_images); // parse this first...!!!
              this.property_type_images = JSON.parse(data[0].property_type_images); // parse this first...!!!
              this.property_mail_images = JSON.parse(data[0].property_mail_images); // parse this first...!!!
              this.property_vehicles_images = JSON.parse(data[0].property_vehicles_images); // parse this first...!!!
              this.property_pets_images = JSON.parse(data[0].property_pets_images); // parse this first...!!!
              this.property_occupancy_images = JSON.parse(data[0].property_occupancy_images); // parse this first...!!!
              this.property_condition_images = JSON.parse(data[0].property_condition_images); // parse this first...!!!


  if ( this.service_file_array != null) {
              console.log('Service File Array: ' + JSON.stringify(this.service_file_array));
              // let  count_of_payment_items = Object.keys(this.service_file_array).length;
           




// new sysetm to filter only notes for agents views.
if (this.gfunc.sessionUserLevel == 5) {
  this.files = [];
console.log('Agent Login Detected: ', this.gfunc.sessionBrandName);
// need to filter the results if exists in the assinged_to_agents array, create a new note array
let array = [];
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let newArr = Object(this.service_file_array).filter((sbi)=>(
  1 === 1
  &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_of_items = Object.keys(newArr).length;
  // 
  for(let i=0;i < count_of_items; i++) {
    let res2 = newArr[i];

    // array = res.assigned_to_agents;
array = JSON.parse(res2.assigned_to_agents);
console.log('array: ', array);

    let ata_array = array.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array.length === 1) {
  this.files.push({
  ...newArr[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.allAttachments = this.files;
/* end brand_type_id agent filter assigned */





// array 2
this.files2 = [];
let array2 = [];
if (this.property_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let newArr2 = Object(this.property_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_of_items2 = Object.keys(newArr2).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_of_items2; i++) {
    let res22 = newArr2[i];

    // array = res.assigned_to_agents;
array2 = JSON.parse(res22.assigned_to_agents);
console.log('array2: ', array2);

    let ata_array2 = array2.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array2.length === 1) {
  this.files2.push({
  ...newArr2[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_images = this.files2;
/* end brand_type_id agent filter assigned */

console.log('Property Images' , JSON.stringify(this.property_images));
}
// end array 2




// array 3
this.files_property_sign_image = [];
let array_property_sign_image = [];
if (this.property_sign_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_sign_image = Object(this.property_sign_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_sign_image = Object.keys(new_property_sign_image).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_sign_image; i++) {
    let res22 = new_property_sign_image[i];

    // array = res.assigned_to_agents;
array_property_sign_image = JSON.parse(res22.assigned_to_agents);
console.log('array_property_sign_image: ', array_property_sign_image);

    let ata_array_property_sign_image = array_property_sign_image.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_sign_image.length === 1) {
  this.files_property_sign_image.push({
  ...new_property_sign_image[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_sign_images = this.files_property_sign_image;
/* end brand_type_id agent filter assigned */

console.log('Property Images' , JSON.stringify(this.property_images));
}
// end array 3



// array 4
this.files_property_type_images = [];
let array_property_type_images = [];
if (this.property_type_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_type_images = Object(this.property_type_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_type_images = Object.keys(new_property_type_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_type_images; i++) {
    let res22 = new_property_type_images[i];

    // array = res.assigned_to_agents;
array_property_type_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_type_images: ', array_property_type_images);

    let ata_array_property_type_images = array_property_type_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_type_images.length === 1) {
  this.files_property_type_images.push({
  ...new_property_type_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_type_images = this.files_property_type_images;
/* end brand_type_id agent filter assigned */

console.log('property_type_images ' , JSON.stringify(this.property_type_images));
}
// end array 4





// array 5
this.files_property_mail_images = [];
let array_property_mail_images = [];
if (this.property_mail_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_mail_images = Object(this.property_mail_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_mail_images = Object.keys(new_property_mail_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_mail_images; i++) {
    let res22 = new_property_mail_images[i];

    // array = res.assigned_to_agents;
array_property_mail_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_mail_images: ', array_property_mail_images);

    let ata_array_property_mail_images = array_property_mail_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_mail_images.length === 1) {
  this.files_property_mail_images.push({
  ...new_property_mail_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_mail_images = this.files_property_mail_images;
/* end brand_type_id agent filter assigned */

console.log('property_mail_images' , JSON.stringify(this.property_mail_images));
}
// end array 5




// array 6
this.files_property_vehicles_images = [];
let array_property_vehicles_images = [];
if (this.property_vehicles_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_vehicles_images = Object(this.property_vehicles_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_vehicles_images = Object.keys(new_property_vehicles_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_vehicles_images; i++) {
    let res22 = new_property_vehicles_images[i];

    // array = res.assigned_to_agents;
array_property_vehicles_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_vehicles_images: ', array_property_vehicles_images);

    let ata_array_property_vehicles_images = array_property_vehicles_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_vehicles_images.length === 1) {
  this.files_property_vehicles_images.push({
  ...new_property_vehicles_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_vehicles_images = this.files_property_vehicles_images;
/* end brand_type_id agent filter assigned */

console.log('property_vehicles_images' , JSON.stringify(this.property_vehicles_images));
}
// end array 6



// array 7
this.files_property_pets_images = [];
let array_property_pets_images = [];
if (this.property_pets_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_pets_images = Object(this.property_pets_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_pets_images = Object.keys(new_property_pets_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_pets_images; i++) {
    let res22 = new_property_pets_images[i];

    // array = res.assigned_to_agents;
array_property_pets_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_pets_images: ', array_property_pets_images);

    let ata_array_property_pets_images = array_property_pets_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_pets_images.length === 1) {
  this.files_property_pets_images.push({
  ...new_property_pets_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_pets_images = this.files_property_pets_images;
/* end brand_type_id agent filter assigned */

console.log('property_pets_images' , JSON.stringify(this.property_pets_images));
}
// end array 7





// array 8
this.files_property_occupancy_images = [];
let array_property_occupancy_images = [];
if (this.property_occupancy_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_occupancy_images = Object(this.property_occupancy_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_occupancy_images = Object.keys(new_property_occupancy_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_occupancy_images; i++) {
    let res22 = new_property_occupancy_images[i];

    // array = res.assigned_to_agents;
array_property_occupancy_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_occupancy_images: ', array_property_occupancy_images);

    let ata_array_property_occupancy_images = array_property_occupancy_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_occupancy_images.length === 1) {
  this.files_property_occupancy_images.push({
  ...new_property_occupancy_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_occupancy_images = this.files_property_occupancy_images;
/* end brand_type_id agent filter assigned */

console.log('property_occupancy_images' , JSON.stringify(this.property_occupancy_images));
}
// end array 8



// array 9
this.files_property_condition_images = [];
let array_property_condition_images = [];
if (this.property_condition_images != null){
// && sbi.file_access_level >= this.gfunc.sessionUserLevel
let new_property_condition_images = Object(this.property_condition_images).filter((sbi)=>(
  1 === 1
 &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId  // prob important
  )); // User this if filter the brand type access level.


// let newArr = data;
let  count_array_property_condition_images = Object.keys(new_property_condition_images).length;
// empty first
// this.property_images = [];

for(let i=0;i < count_array_property_condition_images; i++) {
    let res22 = new_property_condition_images[i];

    // array = res.assigned_to_agents;
array_property_condition_images = JSON.parse(res22.assigned_to_agents);
console.log('array_property_condition_images: ', array_property_condition_images);

    let ata_array_property_condition_images = array_property_condition_images.filter( (n: any) => (
        n.recipient_brand_id === this.gfunc.sessionBrandId
        // n.note_id >= '200'
        // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
        ));

// console.log('ata_array: ', JSON.stringify(res2.ata_array));
// console.log('ata_array.lenght: ', ata_array.length);

// console.log('assigned_to_agents: ', JSON.stringify(res.assigned_to_agents));

// only add if exsists in array

if (ata_array_property_condition_images.length === 1) {
  this.files_property_condition_images.push({
  ...new_property_condition_images[i]
  });
} // end if array.lenght

} // end for loop
// this.service_file_array = this.files;
this.property_condition_images = this.files_property_condition_images;
/* end brand_type_id agent filter assigned */

console.log('property_condition_images' , JSON.stringify(this.property_condition_images));
}
// end array 9


  } // end if agent login



// filter for client files (just filter by brand type.)
  if (this.gfunc.sessionUserLevel == 9) { 
    let newArr = [];

    if (this.service_file_array !== null) { // check if nulls
    let newArr = Object(this.service_file_array).filter((sbi)=>(
      1 === 1
      &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
      )); // User this if filter the brand type access level.
      this.allAttachments = newArr;
    }

      // added for clients.
      newArr = [];
      if (this.property_images !== null) { // check if nulls
      newArr = Object(this.property_images).filter((sbi)=>(
        1 === 1
        &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
        )); // User this if filter the brand type access level.
        this.property_images = newArr;
      }

      // property_sign_images
      newArr = [];
      if (this.property_sign_images !== null) { // check if nulls
      newArr = Object(this.property_sign_images).filter((sbi)=>(
        1 === 1
        &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
        )); // User this if filter the brand type access level.
        this.property_sign_images = newArr;
      }

      // property_type_images
      newArr = [];
      if (this.property_type_images !== null) { // check if nulls
      newArr = Object(this.property_type_images).filter((sbi)=>(
        1 === 1
        &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
        )); // User this if filter the brand type access level.
        this.property_type_images = newArr;
      }

      // property_mail_images
      newArr = [];
      if (this.property_mail_images !== null) { // check if nulls
      newArr = Object(this.property_mail_images).filter((sbi)=>(
        1 === 1
        &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
        )); // User this if filter the brand type access level.
        this.property_mail_images = newArr;
      }


      
      // property_vehicles_images
      newArr = [];
      if (this.property_vehicles_images !== null) { // check if nulls
      newArr = Object(this.property_vehicles_images).filter((sbi)=>(
        1 === 1
        &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
        )); // User this if filter the brand type access level.
        this.property_vehicles_images = newArr;
      }

            // property_pets_images
            newArr = [];
            if (this.property_pets_images !== null) { // check if nulls
            newArr = Object(this.property_pets_images).filter((sbi)=>(
              1 === 1
              &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
              )); // User this if filter the brand type access level.
              this.property_pets_images = newArr;
            }


            // property_occupancy_images
            newArr = [];
            if (this.property_occupancy_images !== null) { // check if nulls
            newArr = Object(this.property_occupancy_images).filter((sbi)=>(
              1 === 1
              &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
              )); // User this if filter the brand type access level.
              this.property_occupancy_images = newArr;
            }


          // property_condition_images
          newArr = [];
          if (this.property_condition_images !== null) { // check if nulls
          newArr = Object(this.property_condition_images).filter((sbi)=>(
            1 === 1
            &&  sbi.brand_type_id === this.gfunc.sessionBrandTypeId
            )); // User this if filter the brand type access level.
            this.property_condition_images = newArr;
          }


  }


   if (this.gfunc.sessionUserLevel <= 4) { 
              let  count_of_payment_items = this.service_file_array.length;

              // now loop and push to join model
              for(let i=0;i < count_of_payment_items; i++) {
                let res2 = this.service_file_array[i];

                  // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                  this.allAttachments.push({
                  //  ...this.service_file_array[i],
                   file_name: res2.file_name,
                   job_file: res2.job_file,
                   subject_file: res2.subject_file,
                   file_id: res2.file_id,
                   file_server_location: res2.file_server_location,
                   file_ext: res2.file_ext,
                   file_brand_id: res2.file_brand_id,
                   file_access_level: res2.file_access_level,
                   assigned_to_agents: res2.assigned_to_agents,
                   brand_type_id: res2.brand_type_id
                          });

              } // end brands loop.
              // this.model.service_file_array = this.allAttachments;

              this.allAttachments = this.allAttachments;
        
        
        
        
        
        
        
        



        



              let array = JSON.parse(data[0].property_type_images); // parse this first...!!!
              if ( array != null) {
              let array_count = array.length;
            // load and push the service image arrays (need to do this for each object of data.)
                      this.property_type_images = [];
                      // this.model.property_type_images = [];
                    for(let i=0;i < array_count; i++) {
                      let res2 = array[i];
                    this.property_type_images.push({ 
                      file_name: res2.file_name,
                      job_file: res2.job_file,
                      subject_file: res2.subject_file,
                      file_id: res2.file_id,
                      file_server_location: res2.file_server_location,
                      file_ext: res2.file_ext,
                      file_brand_id: res2.file_brand_id,
                      file_access_level: res2.file_access_level,
                      assigned_to_agents: res2.assigned_to_agents,
                      brand_type_id: res2.brand_type_id  
                      });
                    }
                    this.property_type_images = this.property_type_images;
                    //  this.model.property_type_images = this.property_type_images;
              };

              array = [];
              array = JSON.parse(data[0].property_images); // parse this first...!!!
              if ( array != null) {
              let array_count = array.length;
                  // load and push the service image arrays (need to do this for each object of data.)
                            this.property_images = [];
                            // this.model.property_images = [];
                          for(let i=0;i < array_count; i++) {
                            let res2 = array[i];
                          this.property_images.push({ 
                            file_name: res2.file_name,
                            job_file: res2.job_file,
                            subject_file: res2.subject_file,
                            file_id: res2.file_id,
                            file_server_location: res2.file_server_location,
                            file_ext: res2.file_ext,
                            file_brand_id: res2.file_brand_id,
                            file_access_level: res2.file_access_level,
                            assigned_to_agents: res2.assigned_to_agents,
                            brand_type_id: res2.brand_type_id  
                            });
                          }
                          this.property_images = this.property_images;
                          //  this.model.property_type_images = this.property_type_images;
              }

                          array = [];
                          array = JSON.parse(data[0].property_sign_images); // parse this first...!!!
                          if ( array != null) {
                          let array_count = array.length;
                              // load and push the service image arrays (need to do this for each object of data.)
                                        this.property_sign_images = [];
                                        // this.model.property_images = [];
                                      for(let i=0;i < array_count; i++) {
                                        let res2 = array[i];
                                      this.property_sign_images.push({ 
                                        file_name: res2.file_name,
                                        job_file: res2.job_file,
                                        subject_file: res2.subject_file,
                                        file_id: res2.file_id,
                                        file_server_location: res2.file_server_location,
                                        file_ext: res2.file_ext,
                                        file_brand_id: res2.file_brand_id,
                                        file_access_level: res2.file_access_level,
                                        assigned_to_agents: res2.assigned_to_agents,
                                        brand_type_id: res2.brand_type_id  
                                        });
                                      }
                                      this.property_sign_images = this.property_sign_images;
                          //  this.model.property_type_images = this.property_type_images;
                                      }

                          array = [];
                          array = JSON.parse(data[0].property_mail_images); // parse this first...!!!
                          if ( array != null) {
                          let array_count = array.length;
                                // load and push the service image arrays (need to do this for each object of data.)
                                        this.property_mail_images = [];
                                        // this.model.property_images = [];
                                        for(let i=0;i < array_count; i++) {
                                        let res2 = array[i];
                                        this.property_mail_images.push({ 
                                        file_name: res2.file_name,
                                        job_file: res2.job_file,
                                        subject_file: res2.subject_file,
                                        file_id: res2.file_id,
                                        file_server_location: res2.file_server_location,
                                        file_ext: res2.file_ext,
                                        file_brand_id: res2.file_brand_id,
                                        file_access_level: res2.file_access_level,
                                        assigned_to_agents: res2.assigned_to_agents,
                                        brand_type_id: res2.brand_type_id  
                                        });
                                        }
                                        this.property_mail_images = this.property_mail_images;
                                        //  this.model.property_type_images = this.property_type_images;
                                      }

                            array = [];
                            array = JSON.parse(data[0].property_vehicles_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_vehicles_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_vehicles_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_vehicles_images = this.property_vehicles_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }

                            array = [];
                            array = JSON.parse(data[0].property_pets_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_pets_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_pets_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_pets_images = this.property_pets_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }
                            array = [];
                            array = JSON.parse(data[0].property_occupancy_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_occupancy_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_occupancy_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_occupancy_images = this.property_occupancy_images;
                            //  this.model.property_type_images = this.property_type_images;
                                        }
                            array = [];
                            array = JSON.parse(data[0].property_condition_images); // parse this first...!!!
                            if ( array != null) {
                            let array_count = array.length;
                                  // load and push the service image arrays (need to do this for each object of data.)
                                          this.property_condition_images = [];
                                          // this.model.property_images = [];
                                          for(let i=0;i < array_count; i++) {
                                          let res2 = array[i];
                                          this.property_condition_images.push({ 
                                          file_name: res2.file_name,
                                          job_file: res2.job_file,
                                          subject_file: res2.subject_file,
                                          file_id: res2.file_id,
                                          file_server_location: res2.file_server_location,
                                          file_ext: res2.file_ext,
                                          file_brand_id: res2.file_brand_id,
                                          file_access_level: res2.file_access_level,
                                          assigned_to_agents: res2.assigned_to_agents,
                                          brand_type_id: res2.brand_type_id  
                                          });
                                          }
                                          this.property_condition_images = this.property_condition_images;
                                        //  this.model.property_type_images = this.property_type_images;
                            }

        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
        
            }
      
       // Put all access to the arrays below... then all the permissions models are sorted for a database field. and model to push data and information. / Dec 2022 Wow!
       
       
       


          } // end admin of all files check















    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 editSubjectContactEmail(model) {
  // model.subject_id = this.subject_id;
 this._demoService.editSubjectContactEmail(model).subscribe(
   data => { 
    //  this.toastr.info('Subject Contact Email Updated');
     this.closeParentModel.emit();
   },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );

}



 addSubjectContactEmail(model) {
   // model.subject_id = this.subject_id;
  this._demoService.createSubjectContactEmail(model).subscribe(
    data => { 
      // this.toastr.info('Subject Contact Email Added');
      this.closeParentModel.emit();
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );

 }



 getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
     let res = data[0];



     // upgrade for returned date too long of time stamp in database to correct format without timezeone I think
     // Issue with created date on now attempts. 2.0?? -- orginal if a timestamp
      console.log('Returned Job Created Date: ' + res.created_date );

  let returned_created_date = res.created_date
  let date_length = returned_created_date.length
  // yourString.substring(0, yourString.length - 3);

  console.log('Date Length: ' + date_length)
  if(date_length == 13 ){
    returned_created_date.substring(0, returned_created_date.length - 3);
    res.created_date = returned_created_date
  }
// end date upgrade march 24

     this.metric_1_date_1 = new Date(res.created_date * 1000);
    //  this.metric_1_date_1 = new Date(res.created_date);

     // fix now I upgraded the job created date. -- ACTIVE WORKING FIX for date Comparisons no JOB start date is no longer a timestamp. --- APPLY THIS FIX IN THE AGENT GRAPHS!!!! -- NOT YET IMPLIMENTED.
     if(this.metric_1_date_1 == 'Invalid Date'){
     this.metric_1_date_1 = new Date(res.created_date);
    }

     this.metric_1_date_2 = new Date(this.date_of_service);
     console.log('metric 1 date view: ', this.metric_1_date_1);
     console.log('metric 2 date view: ', this.metric_1_date_2);
     // tslint:disable-next-line:max-line-length
     this.job_start_date = this.metric_1_date_2.getTime() - this.metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
     this.job_start_date_words = this.gfunc.dhm(this.job_start_date);

   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}




getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.current_subject = data;
      const res = data[0];

        // set for notice and log
        let subject_name = res.first_name + '' + res.surname;
        let subject_business_name = res.business_name;
        
                if(subject_business_name != ''){
                      subject_name = subject_business_name;
                  }
          this.subject_name = subject_name;

      // let metric_1_date_1 = new Date(res.created_date * 1000);
      // let metric_1_date_2 = new Date(this.date_of_service);
      // console.log('metric 1 date view: ', metric_1_date_1);
      // console.log('metric 1 date view: ', metric_1_date_2);
      // this.job_start_date = metric_1_date_2.getTime() - metric_1_date_1.getTime(); // milliseconds // bigger date first so no negatives
      // this.job_start_date_words = this.gfunc.dhm(this.job_start_date);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }


 getSubjectAgentAssigned(subject_id) {
  this._demoService.getSubjectAgentsAssigned(subject_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 getSubjectAttemptType(subject_service_type_id) {
  this._demoService.getSubjectAttemptType(subject_service_type_id).subscribe(
    data => { this.subjectAttemptType = data;
    let res = data[0]
    this.subject_attempt_type_label = res.subject_attempt_type_name;
    },
    err => console.error(err),
  );
  }


 getSubjectAttemptTypes() {
  this._demoService.getSubjectAttemptTypes().subscribe(
    data => { this.subjectAttemptTypesList = data; },
    err => console.error(err),
  );
  }

 getServiceOutcomes() {
  this._demoService.getServiceOutcomes().subscribe(
    data => { this.serviceOutcomes = data; },
    err => console.error(err),
  );
  }

  getServiceMethods() {
  this._demoService.getServiceMethods().subscribe(
    data => { this.serviceMethods = data; },
    err => console.error(err),
  );
  }

  getResolutionOutcomeDisplayData() {
    this._demoService.getSubjectServiceResolutionOutcomes().subscribe(
      (data: any) => this.resolution_outcomes = data || [],
      err => console.error(err),
    );
    this._demoService.getSubjectServiceResolutionOutcomeTypes().subscribe(
      (data: any) => this.resolution_outcome_types = data || [],
      err => console.error(err),
    );
  }

  getResolutionOutcomeDisplay(model: any) {
    return buildResolutionOutcomeDisplay(model, this.resolution_outcomes, this.resolution_outcome_types);
  }


  getSubjectRelationships() {
    this._demoService.getSubjectRelationships().subscribe(
      data => { this.subjectRelationships = data; },
      err => console.error(err),
    );
    }

    getExactServiceMethods() {
      this._demoService.getExactServiceMethods().subscribe(
        data => { this.exactServiceMethods = data; },
        err => console.error(err),
      );
      }


      createSubjectService(model) {
        this.model.subject_id = this.subject_id;
        this.model.job_id = this.job_id;
        this.model.created_by = this.sessionUserId;
        this._demoService.createSubjectService(model).subscribe(
             data => {  this.get_latest_subject_service_id = data; // this is the retuned json upon creation.
              // this.getTraceCandidateNotes(this.trace_candidate_id);
      
             // CreateJob3Component.getTraceCandidateNotes();
      
             // CreateJob3Component.returned.next(false);
              // this.toastr.info('Service Entered!');
              this.getSubjectServices(this.subject_id);

        this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
        this.router.navigate(['admin/jobs/subject/edit/' + model.subject_id + '']));
              
              
              /// Did not worke.
              // refresh the imported subject component
              // SubjectEditComponent.returned.next(false);

               //  return true;
             },
             error => {
              console.log(error(error));
               // return Observable.throw(error);
             }
        );
        }


        getSubjectServices(subject_id) {
          this._demoService.getSubjectServices(subject_id).subscribe(
            data => { this.subject_services = data;
             // console.log("Done loadng USER");
             // console.log(this.users);
             let res = data[0];
             // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
             // this.getUsersById(res.who_attended);
            },
            error => {
            //  console.error('Error Loading User!');
            // return Observable.throw(error);
            }
          ); }



          deleteSubjectService(subject_service_id) {
            if (confirm('Are you sure you want to delete this Service Information? ')) {
              this._demoService.deleteSubjectService(subject_service_id).subscribe(
                 data => {
                  this.getSubjectServices(this.subject_id);
                   return true;
                 },
                 error => {
                   console.error('Error deleting Attendence!');
                  return console.log(error);
                 }
              );
          }
          }



          
          getSubjectServiceOutcome(subject_service_outcome_id) {
            this._demoService.getSubjectServiceOutcome(subject_service_outcome_id).subscribe(
              data => { this.subjectServiceOutcome = data; },
              err => console.error(err),
            );
            } 



            getSubjectLocationStatuss() {
              this._demoService.SubjectLocationStatuss().subscribe(
                data => { this.subjectLocationStatuss = data; },
                err => console.error(err),
              );
              }

              getSubjectLocationStatussFound() {
                this._demoService.SubjectLocationStatussFound().subscribe(
                  data => { this.subjectLocationStatussFound = data; },
                  err => console.error(err),
                );
                }

                // for select items
                onSelectionChange(entry) {
                 // this.selectedEntry = entry;
                  this.model.subject_location_status_found_id = entry; // changes or updates via selection of radio button group
                }


                // for select items
                onSelectionChangeVehicles(entry) {
                // this.selectedEntry = entry;
                this.model.vehicles = entry; // changes or updates via selection of radio button group
               // this.model.vehicles_notes = 'here are my notes.'
              }
              // for select items
              onSelectionChangeNeighbours(entry) {
                // this.selectedEntry = entry;
                  this.model.neighbours = entry; // changes or updates via selection of radio button group
                }
                onSelectionChangeCallingCard(entry) {
                  // this.selectedEntry = entry;
                    this.model.calling_card = entry; // changes or updates via selection of radio button group
                  };
                  onSelectionChangeMail(entry) {
                    // this.selectedEntry = entry;
                      this.model.postal_mail = entry; // changes or updates via selection of radio button group
                    }
                    onSelectionChangePhoneCall(entry) {
                      // this.selectedEntry = entry;
                        this.model.phone_call = entry; // changes or updates via selection of radio button group
                      }
                      onSelectionChangeAttempts(entry) {
                        // this.selectedEntry = entry;
                          this.model.attempts = entry; // changes or updates via selection of radio button group
                        }
                        onSelectionChangePersonType(entry) {
                          // this.selectedEntry = entry;
                            this.model.person_type = entry; // changes or updates via selection of radio button group
                          }
                


                          clearChecked(field, model){
                           model.vehicles = false;
                           model.vehicles_notes = null;
                          // this.attemptForm.controls['radiogroup2'].setValue(null);
                          // this.attemptForm.setValue({radiogroup2: '', radiogroup3: true});
                          }
                          clearCheckedNeighbours(field, model){ model.neighbours = false; model.neighbours_notes = null;}
                          clearCheckedCallingCard(model){ model.calling_card = false; model.calling_card_notes = null;}
                          clearCheckedPostalMail(model){ model.postal_mail = false; model.mail_notes = null;}
                          clearCheckedPhoneCall(model){ model.phone_call = false; model.phone_call_notes = null;}
                          clearCheckedAttempts(model){ model.attempts = false; model.attempts_notes = null;}
                          clearCheckedPersonType(model){ model.person_type = false; model.person_type_notes = null;}

                // for select items
                onChangeServiceCount(model) {
                  this.model.service_number = 0;   
                  model.job_id = this.job_id;
                  model.subject_id = this.subject_id;
                 // look (count) up job_id, subject_id, agent id attendences + 1
                 this.getJobSubjectAttendancesCountNumber(model);
                // set model.service_number = results.
                

                 }


                 getJobSubjectAttendancesCountNumber(model){
                  this._demoService.getJobSubjectAttendancesCountNumber(model).subscribe(
                    data => { this.current_service_number = data; 
                      this.converted_service_number = Number(this.current_service_number);
                                        // this.selectedEntry = entry;
                  let increment = Number(this.converted_service_number + 1);
                  this.model.service_number = increment; // changes or updates via selection of radio button group

                    console.log(data);
                    },
                    err => {console.error(err)
                      // set to one if there is an error because it means subject id cannot be found
                      this.model.service_number = 1;
                    },
                  );

                 }


// :: Attempts - 2022 Upgrades

                 //:: Set the label for all naming conventions
setAttemptType(model) {
    this.subject_attempt_type_label = (<HTMLSelectElement>document.getElementById('subject_attempt_type_id')).selectedOptions[0].text;
    console.log('Attempt Type Task: ' +  this.subject_attempt_type_label);
  //  const doc_name = document.getElementById('doc_name').innerText;
  //  console.log('Document Name: ' +  doc_name);

  // :: Set Some Defaults
  // Attempt - Servive
  if(model.subject_attempt_type_id == 1 ){
    this.model.subject_service_outcome_id = 1; // outcome default is served.
    this.attemptForm.controls['subject_service_outcome_id'].setValue('1');
  }

}


editSubjectService(model){
  this._demoService.editSubjectService(model).subscribe(
    data => { // this.current_subject = data;
     const res = data[0];
    //  this.toastr.success('Attempt Details Updated');
      this.closeParentModel.emit();
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }


  copyToClipboard(id) {
    const content = document.getElementById(id).innerHTML; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }
  
  copyToClipboardPlainText(id) {
    const content = document.getElementById(id).innerText; // copy all formatting.
    // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
    // this.clipboard.copy(this.removeTags(content));
    this.clipboard.copy(content);
    this,this.toastr.info(" Copied")
    // this.copyInGrid('btnTwo', id);
  }




}
